import React, { Component, useEffect } from 'react'
import Banner from '../../Slider/Banner';
import { FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faEnvelope , faMoneyBill, faMoneyBillWave, faCalendarCheck} from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faLinkedin, faDribbble, faInstagram, faPaypal, } from '@fortawesome/free-brands-svg-icons'
import { useSelector, useDispatch } from 'react-redux';
import WhatsApp from '@material-ui/icons/WhatsApp';
import Email from '@material-ui/icons/Email';
import ContactSupport from '@material-ui/icons/ContactSupport';
import CallIcon from '@material-ui/icons/Call';
import HowItWorks from '../../HowItWorks/HowItWorks';
import Slider from '../../Slider/Slider';
import Carousel from 'react-multi-carousel';
import Card from 'react-bootstrap/Card';
import Rating from '@material-ui/lab/Rating'
import { ButtonToolbar } from 'react-bootstrap';
import { Link, withRouter } from 'react-router-dom';



const bannerData = [
  {
    imagePath: 'https://cash4device.s3.ca-central-1.amazonaws.com/home_page_carousel/1.png',
    alt: 'Sell your macbook for the best value',
    mainContent: 'SELL SMART & SAFE',
    subContent: '',
  },
  {
    imagePath: 'https://sellmydevice.s3.ca-central-1.amazonaws.com/Carousel/Sell+your+iPhone.jpg',
    alt: 'i-pad',
    mainContent: 'SELL SMART & SAFE',
    subContent: '',
  },
  {
    imagePath: 'https://cashmydevice-home-page-images.s3.amazonaws.com/GooglePixel.png',
    alt: 'mac-book',
    mainContent: 'SELL SMART & SAFE',
    subContent: '',
  },
  {
    imagePath: 'https://cashmydevice-home-page-images.s3.amazonaws.com/AirPods.jpeg',
    alt: 'ear-buds',
    mainContent: 'SELL SMART & SAFE',
    subContent: '',
  },
  {
    imagePath: 'https://cashmydevice-home-page-images.s3.amazonaws.com/iwatch.jpeg',
    alt: 'smart-watch',
    mainContent: 'SELL SMART & SAFE',
    subContent: '',
  },
];

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  superLargeDesktop: {
    breakpoint: { max: 1024, min: 600 },
    items: 3
  },
  tablet: {
    breakpoint: { max: 600, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};
const handleClick =(value)=>{
 
}

class HomePage extends Component {
  

  render() {
  
    return (
      <div className=''>
    
   <div style={{backgroundColor:''}} className=''>
   <Slider/>
          
          <div className='p-2  border bg-light-gray'>
          <span style={{fontSize:20, fontWeight:500, textAlign:"center"}}>What our customers are saying</span>
         
          
          
        <div style={{maxWidth:"px", justifyContent:"center"}} className=" justify-content-center">
          <Carousel
            showDots={true}
            autoPlay={false}
            responsive={responsive}
            infinite={true}
            keyBoardControl={true}
            removeArrowOnDeviceType={["mobile"]}
            containerClass="carousel-container"
            dotListClass="mt-4 custom-dot-list-style"
            itemClass="carousel-item-padding-40-px"
          >
            
            <div style={{boxShadow:"4px  2px 2px gray"}}className="mb-2 ml-2 mr-2 bg-white  p-4 h-100">
                  <div>
                    <span style={{fontSize:20, fontWeight:400}}>  Jason Bourne </span>
                  </div>
                <img className="slider-img w-10" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

                <Rating className=" mt-3" name="read-only" value={5} readOnly />
              <div class="mt-3">
                <span style={{fontSize:15, fontWeight:400}}> 
                  <i class="fa fa-quote-left" aria-hidden="true">
                  </i> I sold my iPhone 11 Pro since it was sitting and accumulating dust in my drawer,  I  got an instant offer better than anywhere else! The customer service was very helpful in letting me know about the all steps involve in successful trade in.
                 </span>
              </div>
            </div>

            <div className="mb-2 ml-2 mr-2 bg-white p-4 h-100">
                  <div>
                    <span style={{fontSize:20, fontWeight:400}}>  Ashley B. </span>
                  </div>
                <img className="slider-img w-10" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

                <Rating className=" mt-3" name="read-only" value={5} readOnly />
              <div class="mt-3">
                <span style={{fontSize:15, fontWeight:400}}> 
                  <i class="fa fa-quote-left" aria-hidden="true">
                  </i> Was looking for a platform to sell my 5th generation, 2017 iPad and my 13” MacBook Pro (no touch bar). Sell My Device was a great option because I was able to get a great value for my device and can now afford to upgrade the latest version in the product lineup! Thanks!
                 </span>
              </div>
            </div>

            <div className="mb-2 ml-2 mr-2  bg-white p-4 h-100">
                  <div>
                    <span style={{fontSize:20, fontWeight:400}}> Gabe Barrett </span>
                  </div>
                <img className="slider-img w-10" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

                <Rating className=" mt-3" name="read-only" value={5} readOnly />
              <div class="mt-3">
                <span style={{fontSize:15, fontWeight:400}}> 
                  <i class="fa fa-quote-left" aria-hidden="true">
                  </i> Great customer experience. The reps at cash4device gave me a quote and notified me how to ship my device safely and securely. Easy to navigate website and timely service.
                 </span>
              </div>
            </div>


            <div className="mb-2 ml-2 mr-2 bg-white p-4 h-100">
                  <div>
                    <span style={{fontSize:20, fontWeight:400}}>  Alex Smith </span>
                  </div>
                <img className="slider-img w-10" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

                <Rating className=" mt-3" name="read-only" value={5} readOnly />
              <div class="mt-3">
                <span style={{fontSize:15, fontWeight:400}}> 
                  <i class="fa fa-quote-left" aria-hidden="true">
                  </i> I sold my iPhone 14 Pro Max since i updgraded to iPhone 15 Pro Max, was offered a lot better value as compare to carrier's device upgrade program!
                 </span>
              </div>
            </div>

            <div className="mb-2 ml-2 mr-2 bg-white p-4 h-100">
                  <div>
                    <span style={{fontSize:20, fontWeight:400}}>  Simarjeet Kaur </span>
                  </div>
                <img className="slider-img w-10" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Misc_Sellmydevices/Google__G__logo.svg.png"/> 

                <Rating className=" mt-3" name="read-only" value={5} readOnly />
              <div class="mt-3">
                <span style={{fontSize:15, fontWeight:400}}> 
                  <i class="fa fa-quote-left" aria-hidden="true">
                  </i> I sold my iPhone 13 Pro, I was offered better deal than what was offered at my local computer store. They came to the rescue me to get right value for my iPhone.
                 </span>
              </div>
            </div>

          </Carousel>
        </div>
        </div>
        <div className="p-2">
        <div className='border bg-floralwhite border-dark-white rounded-lg p-2 mb-5'>
          <span style={{fontSize:21, fontWeight:700, textAlign:"left", margin:20}}>  How it works(Shipping label method): </span>
          <div className='grid-container'>
              <div style={{backgroundColor:"", borderStyle:"", marginTop:"10px", boxShadow:"3px 4px 2px gray"}} className='grid-item '>
              <div style={{columnGap:"0.1rem", justifyContent:"center", }}className='d-flex  '> 
              <div> <i class="fa fa-mobile fa-8x " style={{color:"", marginLeft:""}} ></i></div>
              <div className="grid-container1 ml-2 ">
              <i class="fa fa-check-square fa-2x"></i>
              <i class="fa fa-check-square fa-2x"></i>
              <i class="fa fa-check-square fa-2x"></i>
              
              </div>
              
              </div>
               <div className='text-dark mb-2 mt-2 justify-content-center'>
                
                  <span  style={{fontSize:16, fontWeight:600, }}className=''>Provide the information needed for your device.</span>
                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> We'll provide an instant offer on the basis of your provided information.</span>
                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You accept the offer and complete the trasnaction by following the steps.</span>
                
                    
                  </div>
                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 1</button>
              </div>
                 
              <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
              <div style={{columnGap:"0.1rem", justifyContent:"center"}}className='d-flex '> 
              <div><i class="fa fa-truck fa-6x" style={{color:"", marginLeft:""}} ></i></div>
              </div>
               <div className='ext-dark mb-2 mt-2 justify-content-center'>
                    <span  style={{fontSize:16, fontWeight:600}}className='p-2'>We'll send you a prepaid shipping label right after the submission to your email.</span>
                    <span  style={{fontSize:16, fontWeight:600, }}className=''>You will use provided shipping label to send your device(s) to us at no cost to you.</span>
                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You can schedule pickup with carrier or drop it off yourself.</span>
                 
                  </div>
                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 2</button>
               </div>
                
                  
              <div style={{backgroundColor:"floral-white",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
              <div className=''> 
              <div> <FontAwesomeIcon icon={faMoneyBillWave} style={{fontSize:"100px"}}/></div>
              </div>
              <div className='text-dark mb-2 mt-2 justify-content-center'>
                    <span  style={{fontSize:16, fontWeight:600}}className=''>Upon receiving device (s), we inspect the device (s) to validate the information provided by you on website.</span>
                    <span  style={{fontSize:16, fontWeight:600, }}className=''> At the end of inspection, we process the payment immediately.</span>
                    <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You get paid with the payment method of your choice like Cash, PayPal, E-trasfer(Interac).</span>
                  </div>
                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 3</button>
               </div>
                    
            
          </div> 
        </div>
        <div className='border bg-floralwhite border-dark-white rounded-lg p-2 mb-5'>
          <span style={{fontSize:19, fontWeight:700, textAlign:"left", margin:20}}>  How it works(In person meeting method): </span>
          <div className='grid-container'>
              <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item '>
              <div style={{columnGap:"0.1rem", justifyContent:"center", }}className='d-flex  '> 
              <div> <i class="fa fa-mobile fa-8x " style={{color:"", marginLeft:""}} ></i></div>
              <div className="grid-container1 ml-2 ">
              <i class="fa fa-check-square fa-2x"></i>
              <i class="fa fa-check-square fa-2x"></i>
              <i class="fa fa-check-square fa-2x"></i>
              
              </div>
              
              </div>
               <div className='text-dark mb-2 mt-2 justify-content-center'>
                
                  <span  style={{fontSize:16, fontWeight:600, }}className=''>Provide the information needed for your device.</span>
                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> We'll provide an instant offer on the basis of your provided information.</span>
                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You accept the offer and complete the trasnaction by following the steps.</span>
                
                    
                  </div>
                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 1</button>
              </div>
                 
              <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
              <div style={{columnGap:"0.1rem", justifyContent:"center"}}className='d-flex '> 
              <div><FontAwesomeIcon icon={faCalendarCheck} style={{fontSize:"100px"}}/></div>
              </div>
               <div className='ext-dark mb-2 mt-2 justify-content-center'>
                    <span  style={{fontSize:16, fontWeight:600}}className='p-2'>Our assocciate will contanct you, to schedule an appointment with you as per your availability.</span>
                    <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''>You will receive appointment cofirmation details on your email. </span>
                    <span  style={{fontSize:16, fontWeight:600, }}className=''>You will meet our associate at your scheduled time and place.</span>
                
                 
                  </div>
                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 2</button>
               </div>
                
                  
              <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
              <div className=''> 
              <div> <FontAwesomeIcon icon={faMoneyBillWave} style={{fontSize:"100px"}}/></div>
              </div>
              <div className='text-dark mb-2 mt-2 justify-content-center'>
                    <span  style={{fontSize:16, fontWeight:600}}className=''>Associate will inspect the device (s) on the spot and validate the information provided by you on website.</span>
                    <span  style={{fontSize:16, fontWeight:600, }}className=''> At the end of inspection, we process the payment immediately.</span>
                    <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You get paid with the payment method of your choice like Cash, PayPal, E-trasfer(Interac).</span>
                  </div>
                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 3</button>
               </div>
                    
            
          </div> 
        </div>
        </div>
        <div className="p-2 border border-dark-white rounded-lg ">
        <div className='p-2 mb-5'>
          <span style={{fontSize:22, fontWeight:800, textAlign:"left", margin:20}}>  Frequently traded devices: </span>
          <div  style={{overflow:"scroll"}}className='d-flex'>
                <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray",width:"200px"}} className='grid-item3'>
                  <div style={{justifyContent:"center",textAlign:"center"}}>
                  <img className="bg-white w-80 " src="https://sellmydevice.s3.ca-central-1.amazonaws.com/iPhone/iphone-15-pro-max.png"></img>
                  </div>
                  <div style={{justifyContent:"center",textAlign:"center"}}className='ml-2'>
                    <span  style={{fontSize:17, color:"black",fontWeight:600,}}className='p-2'>iPhone 15 Pro Max 256GB Natural Titanium</span>
                  </div >
                <div style={{alignContent:"center",justifyContent:"center"}}>
               <Link to="/iPhone/iPhone 15 Pro Max">
                <button style={{fontSize:"21.5px", fontWeight:500,  backgroundColor:"#FDBB2D"}}className='border border-dark rounded-lg text-dark w-100 w-100'>Trade-in Now</button>
             </Link>
              </div>
                </div>
                 
                <div style={{boxShadow:"3px 4px 2px gray",width:"200px" }} className='grid-item3'>
                  <div style={{justifyContent:"center",textAlign:"center"}}>
                  <img className="w-80  " src="https://sellmydevice.s3.ca-central-1.amazonaws.com/iPhone/iphone-13-pro-max.jpg"></img>
                  </div>
                  <div style={{justifyContent:"center",textAlign:"center"}}className='ml-2'>
                    <span  style={{fontSize:17, fontWeight:600, color:"black"}}className='p-2'>iPhone 13 Pro Max 256GB Sieraa Blue variant</span>
                  </div >
                <div style={{alignContent:"center"}}>
                 <Link to="/iPhone/iPhone 13 Pro Max">
                <button style={{fontSize:"21.5px", fontWeight:500,  backgroundColor:"#FDBB2D"}}className='border border-dark rounded-lg text-dark w-100'>Trade-in Now</button>
                 </Link>
                  </div>
                </div>
                  
                <div style={{boxShadow:"3px 4px 2px gray", width:"200px"}} className='grid-item3'>
                  <div style={{justifyContent:"center",textAlign:"center"}}>
                  <img className="w-80 " src="https://sellmydevice.s3.ca-central-1.amazonaws.com/iPad/ipad_pro_gen/ipad-pro-129-inch-6th-gen.jpg.webp"></img>
                  </div>
                  <div style={{justifyContent:"center",textAlign:"center"}}className='ml-2'>
                    <span  style={{fontSize:17, fontWeight:600, color:"black"}}className='p-2'>iPad Pro 6th Generation 256GB 12.9" WiFi </span>
                  </div >
                <div style={{alignContent:"center"}}>
                 <Link to="/iPad/iPad Pro">
                <button style={{fontSize:"21.5px", fontWeight:500,  backgroundColor:"#FDBB2D"}}className='border border-dark rounded-lg text-dark w-100'>Trade-in Now</button>
               </Link>
                </div>
                </div>

               <div style={{boxShadow:"3px 4px 2px gray",width:"200px"}} className='grid-item3'>
                  <div style={{justifyContent:"center",textAlign:"center"}}>
                  <img className="w-80" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/Macbook/Macbook+Pro/MacbookPro2012-2015/macbook-pro-16-touch-bar.jpg.webp"></img>
                  </div>
                  <div style={{justifyContent:"center",textAlign:"center"}}className='ml-2'>
                    <span  style={{fontSize:17, fontWeight:600, color:"black"}}className='p-2'>MacBook Pro 16" 2019-i9-16GB-1TB Space Gray</span>
                  </div >
                <div style={{alignContent:"center"}}>
                 <Link to="/Macbook/MacBook Pro">
                <button style={{fontSize:"21.5px", fontWeight:500,  backgroundColor:"#FDBB2D"}}className='border border-dark rounded-lg text-dark w-100'>Trade-in Now</button>
               </Link>
                </div>
                </div>

                <div style={{boxShadow:"3px 4px 2px gray",width:"200px"}} className='grid-item3'>
                  <div style={{justifyContent:"center",textAlign:"center"}}>
                  <img className="w-80  bg-white" src="https://sellmydevice.s3.ca-central-1.amazonaws.com/iWatches/iwatch-ultra-2.png"></img>
                  </div>
                  <div style={{justifyContent:"center",textAlign:"center"}}className='ml-2'>
                    <span  style={{fontSize:17, fontWeight:600, color:"black"}}className='p-2'>iWatch Ultra 2 Stainless Steel case 49mm</span>
                  </div >
                <div style={{alignContent:"center"}}>
                 <Link to="/iWatch/Apple Watch Ultra 2">
                  <button style={{fontSize:"21.5px", fontWeight:500,  backgroundColor:"#FDBB2D"}}className='border border-dark rounded-lg text-dark w-100' onClick={handleClick()}>Trade-in Now</button>
                 </Link>
              
               
               </div>
                </div>
            
          </div> 
        </div>
        <div style={{backgroundColor: "",}}className='bg-light p-2'>
          <span style={{fontSize:22, fontWeight:800, textAlign:"left", margin:20, }}>  Why trade in with us? </span>
          <div className='grid-container '>
          <div style={{ backgroundColor: "floralwhite",textAlign:"left",fontSize:14, fontWeight:500,boxShadow:"3px 4px 2px gray", backgroundImage:'url("https://cash4device.s3.ca-central-1.amazonaws.com/data_protection")',backgroundSize:"390px 200px", backgroundRepeat:"no-repeat"}}   className='grid-item'>
           
            <div className='mt-10'>
            <span style={{fontSize:17, fontWeight:600, textAlign:"center"}}>Benefit of selling your device to us.</span>
            <hr></hr>
            <ul>
              <li>We ensure to erase and factory reset your device (s) by data scrubbing and permanetly deleting any data on it.</li>
              <li><span className="text-dark">We are pioneer in e-waste recycling.</span></li>
              <li>Safest way to recycle your old electronics and get paid for it.</li>
              <li>We use cutting-edge technology to recycle your devices.</li>
            </ul>
            </div>
               </div>
                 
                <div style={{backgroundColor: "floralwhite",textAlign:"left",fontSize:14, fontWeight:500,boxShadow:"3px 4px 2px gray",backgroundImage:'url("https://cash4device.s3.ca-central-1.amazonaws.com/seamless_process")',backgroundSize:"390px 200px", backgroundRepeat:"no-repeat", }}   className='grid-item'>
               <div className='mt-10'>
               <span style={{fontSize:17, fontWeight:600, textAlign:"left", }}>Smart and secure way to recycle your old devices.</span>
                <hr></hr>
                <ul>
                <li>We offer a very convenient and secure platform to sell your device (s).</li>
                <li>You can know the worth of your devices in less than a minute.</li>
                <li>Ship your device at your convenience.</li>
                <li>Get updates on every step your trad in takes.</li>
                <li>Get paid instantly via your preferred payment method—Cash, E-transfer (Interac), or PayPal.</li>
              </ul>
               </div>
                
                </div>
                  
                <div style={{backgroundColor: "floralwhite",textAlign:"left",fontSize:14, fontWeight:500,boxShadow:"3px 4px 2px gray",backgroundImage:'url("https://cash4device.s3.ca-central-1.amazonaws.com/semaless_process_2")',backgroundSize:"390px 200px", backgroundRepeat:"no-repeat", }}   className='grid-item'>
                <div className='mt-10'>
                <span style={{fontSize:17, fontWeight:600, textAlign:"left", }}>Secure and hassle-free process.</span>
                <hr></hr>
                <ul>
                <li><span className="text-dark">We provide WhatsApp chat-based customer support, along with 10–5 phone support.</span></li>
                <li><span className="text-dark">We make sure to resolve any issue within a day.</span></li>
                <li><span className="text-dark">Our customer support team consists of trained professionals, experts at resolving customer issues and providing the best possible solutions.</span></li>
                <li>We offer the way to track status of your trade in any time.</li>
              </ul> 
              </div>
                </div>
                <div style={{backgroundColor: "floralwhite",textAlign:"left",fontSize:14, fontWeight:500,boxShadow:"3px 4px 2px gray",backgroundImage:'url("https://cash4device.s3.ca-central-1.amazonaws.com/whyselltous/customer_support.png")',backgroundSize:"390px 200px", backgroundRepeat:"no-repeat", }}   className='grid-item'>
                <div className='mt-10 '>
                <span style={{fontSize:17, fontWeight:600, textAlign:"left", }}>Best customer support in the industry.</span>
                <hr></hr>
                <ul>
                <li>We pay the best trade in value for your device (s) in the industry.</li>
                <li>We pay in cash, not store credit.</li>
                <li>We provide a prepaid shipping label so you can ship your devices to us free of charge.</li>
                <li>We offer same-day payments upon receiving your device via your preferred method (Interac, cash, PayPal).</li>
                <li>
                  We offer a fast and easy way to check your device’s value. 
                  <Link className="text-danger cursor-pointer" to="/SellAdevice">
                    <u> Find out the worth of your device</u>
                 </Link>
                </li>
               
              </ul>
              </div>
               </div>
            
          </div> 
        </div>
        </div>
        <div className='bg-light p-2 '>
          <span style={{fontSize:20, fontWeight:800, textAlign:"left", margin:20}}>  Get paid instantly  </span>
          <div className='grid-container'>
                <div style={{backgroundColor:"floralwhite", borderRadius:"30px",boxShadow:"3px 4px 2px gray" ,display:"flex", columnGap:"1x"}}className=''>
                
                  <div style={{boxShadow:"",}}className='w-50 '>
                  <div style={{fontSize:"60px", marginLeft:"2rem"}} className="w-80">
                  <FontAwesomeIcon icon={faPaypal} />
                  </div>
                 
                  </div>
                 <div className='p-2 ml-2'> 
                 <span style={{fontSize:16, fontWeight:700}}> Get paid instantly, just provide your email address to get paid by PayPal.</span>
                 </div>
           </div>
                 
           
               <div style={{backgroundColor:"floralwhite", borderRadius:"30px",boxShadow:"3px 4px 2px gray", display:"flex", columnGap:"1x" }}className='  '>
                  <div className='w-50'>
                  <img className="w-75 p-1 ml-2 mt-3" style={{background:''}} src="https://cash4device.s3.ca-central-1.amazonaws.com/payment_method/Interac_Brand_2021.png"></img>
                  </div>
                  <div className='p-2 ml-2'> 
                  <span style={{fontSize:16, fontWeight:700}}className="">Get paid instantly, just provide your email address to get paid by interac.</span>
                  </div>
                 </div>
               
                  
                <div style={{backgroundColor:"floralwhite", borderRadius:"30px",boxShadow:"3px 4px 2px gray" ,display:"flex", columnGap:"1x"}}className=' '>
                <div className='w-50'>
                  <img className=" w-80 p-2 ml-2 " style={{background:''}} src="https://cash4device.s3.ca-central-1.amazonaws.com/payment_method/payment-icon-5646.png"></img>
                  </div>
                  <div style={{marginLeft:"20px"}}className='p-2 '> 
                  <span style={{fontSize:15, fontWeight:700, }}className="">Get paid instantly, Schedule a meeting to meet in person with our associate to get paid cash.</span>
                 </div>
                  </div>
          </div> 
        </div>
         
    </div>
        <div>
        <footer className="footer">
              <div className="container ">
                  <div className="row">
                     
                      <div className='col-lg-3 mb-5 mb-lg-0'>
                <div className='footer-menu'>
                  <ul>
                  <li><Link to="/SellAdevice">Trade in apple products</Link></li>
                  <li><Link to="/SellAdevice">Recycle for free</Link></li>
                  <li><Link to="/SellAdevice">Recycle in canada</Link></li>
                  <br></br>
                  <li><Link to="/SellAdevice">Trade-in in Toronto</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Vancouver</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Montreal</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Winnipeg</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Edmonton</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Calgary</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Ottawa</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Hamilton</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Quebec city</Link></li>
                  <li><Link to="/SellAdevice">Trade-in in Halifax</Link></li>
                </ul>

                </div>
                </div>
                   

                      

                      <div className="col-lg-3 mb-5 mb-lg-0">
                          <div className="footer-menu">
                            <div className='d-flex'>
                            <ul>
                            <li><Link to='/WhySellToUs'>About</Link></li>
                            <li><Link to='/Support/CustomerSupport'>Contact</Link></li>
                            <li><Link to='/SellBulk'>Bulk Sales</Link></li>
                            <br />
                            <li><Link to='/iPhone'>Sell iPhone</Link></li>
                            <li><Link to="/iPad">Sell iPad</Link></li>
                            <li><Link to='/Macbook'>Sell MacBook</Link></li>
                            <li><Link to='/iWatch'>Sell iWatch</Link></li>  
                            <li><Link to='/AirPods'>Sell AirPods</Link></li>  
                            <li><Link to="/iPhone/iPhone 16 Pro Max">Sell iPhone 16 Pro Max</Link></li>                                    
                            <li><Link to="/iPhone/iPhone 16 Pro">Sell iPhone 16 Pro</Link></li>
                            <li><Link to="/iPhone/iPhone 16 Plus">Sell iPhone 16 Plus</Link></li>
                            <li><Link to="/iPhone/iPhone 16">Sell iPhone 16</Link></li>
                            <li><Link to="/iPhone/iPhone 15 Pro Max">Sell iPhone 15 Pro Max</Link></li>
                            <li><Link to="/iPhone/iPhone 15 Pro">Sell iPhone 15 Pro</Link></li>
                            <li><Link to="/iPhone/iPhone 15 Plus">Sell iPhone 15 Plus</Link></li>
                            <li><Link to="/iPhone/iPhone 15">Sell iPhone 15</Link></li>
                            <li><Link to="/iPhone/iPhone 14 Pro Max">Sell iPhone 14 Pro Max</Link></li>
                            <li><Link to="/iPhone/iPhone 14 Pro">Sell iPhone 14 Pro</Link></li>
                            <li><Link to="/iPhone/iPhone 14 Plus">Sell iPhone 14 Plus</Link></li>
                            <li><Link to="/iPhone/iPhone 14">Sell iPhone 14</Link></li>
                            <li><Link to="/iPhone/iPhone SE 3rd">Sell iPhone SE (3rd)</Link></li>
                            <li><Link to="/iPhone/iPhone 13 Pro Max">Sell iPhone 13 Pro Max</Link></li>
                            <li><Link to="/iPhone/iPhone 13 Pro">Sell iPhone 13 Pro</Link></li>
                              </ul>
                              
                            </div>
                            <div>
                            
                            </div>
                              
                          </div>
                          
                      </div>
                      <div className='col-lg-3 mb-5 mb-lg-0'>
                        <div className='footer-menu'>
                      <ul>
                      <li><Link to='Support/Faq'>FAQ</Link></li>
                <li><Link to='/Support/TrackYourOrder'>Track your trade</Link></li>
                <li><Link to='/WhySellToUs/Process'>How it works</Link></li>
                <br />
                <li><Link to='/iPad/iPad Pro'>Sell iPad Pro</Link></li>
                <li><Link to="/iPad/iPad Mini">Sell iPad Mini</Link></li>
                <li><Link to='/iPad/iPad'>Sell iPad</Link></li>
                <li><Link to='/iPad/iPad Pro'>Sell iPad Pro M4</Link></li>
                <li><Link to='iPad/iPad Pro'>Sell iPad Pro 1st Gen</Link></li>
                <li><Link to='iPad/iPad Pro'>Sell iPad Pro 2nd Gen</Link></li>
                <li><Link to='iPad/iPad Pro'>Sell iPad Pro 3rd Gen</Link></li>
                <li><Link to='iPad/iPad Pro'>Sell iPad Pro 4th Gen</Link></li>
                <li><Link to='iPad/iPad Pro'>Sell iPad Pro 5th Gen</Link></li>
                <li><Link to='iPad/iPad Pro'>Sell iPad Pro 6th Gen</Link></li>
                <li><Link to='iPad/iPad Pro'>Sell iPad Pro 9.7"</Link></li>
                <li><Link to='iPad/iPad Pro'>Sell iPad Pro 10.5"</Link></li>
                <li><Link to='/iPad/iPad Air'>Sell iPad Air</Link></li>
                <li><Link to='iPad/iPad Air'>Sell iPad Air 3rd Gen</Link></li>
                <li><Link to='iPad/iPad Air'>Sell iPad Air 4th Gen</Link></li>
                <li><Link to='iPad/iPad Air'>Sell iPad Air 5th Gen</Link></li>
                <li><Link to='iPad/iPad Air'>Sell iPad Air M2</Link></li>
                <li><Link to="/iPad/iPad Mini">Sell iPad Mini A17 Pro</Link></li>
                <li><Link to="iPad/iPad Mini">Sell iPad Mini 3rd Gen</Link></li>
                <li><Link to="iPad/iPad Mini">Sell iPad Mini 4th Gen</Link></li>
                <li><Link to="iPad/iPad Mini">Sell iPad Mini 5th Gen</Link></li>
                <li><Link to="iPad/iPad Mini">Sell iPad Mini 6th Gen</Link></li>
                <li><Link to="iPad/iPad">Sell iPad 5th Gen</Link></li>
                <li><Link to="iPad/iPad">Sell iPad 6th Gen</Link></li>
                <li><Link to="iPad/iPad">Sell iPad 7th Gen</Link></li>
                <li><Link to="iPad/iPad">Sell iPad 8th Gen</Link></li>
                <li><Link to="iPad/iPad">Sell iPad 9th Gen</Link></li>
                <li><Link to="iPad/iPad">Sell iPad 10th Gen</Link></li>
                <li><Link to="iPad/iPad">Sell iPad A16</Link></li>
                  </ul>
                              </div>
                      </div>
              <div className='col-lg-3 mb-5 mb-lg-0'>
              <div className='footer-menu'>
                <ul>
                <li><Link to="/SellAdevice">Trade in Apple gadgets</Link></li>
                <li><Link to="/otherDevice">Sell PS5</Link></li>
                <li><Link to="/otherDevice">Sell Nintendo</Link></li>
                <br />
                <li><Link to="/iWatch/Apple Watch Ultra 2">Sell iWatch Ultra 2</Link></li>
                <li><Link to="/iWatch/Apple Watch (Series 9)">Sell iWatch Series 9</Link></li>
                <li><Link to="/iWatch/Apple Watch Ultra">Sell iWatch Ultra</Link></li>
                <li><Link to="/iWatch/Apple Watch (SE) 2nd Gen.">Sell iWatch SE 2nd Gen</Link></li>
                <li><Link to="/iWatch/Apple Watch (Series 8)">Sell iWatch Series 8</Link></li>
                <li><Link to="/iWatch/Apple Watch (Series 7)">Sell iWatch Series 7</Link></li>
                <li><Link to="/iWatch/Apple Watch (Series 6)">Sell iWatch Series 6</Link></li>
                <li><Link to="/iWatch/Apple Watch (Series 5)">Sell iWatch Series 5</Link></li>
                <li><Link to="/iWatch/Apple Watch (Series 10)">Sell iWatch Series 10</Link></li>

                </ul>
                </div>
                </div>
                <div className='col-lg-3 mb-5 mb-lg-0'>
                <div className='footer-menu'>
                <ul>
                <li><Link to="/WhySellToUs/Recycle">Recycle old gadgets</Link></li>
                  <li><Link to="/Airpods/AirPods Pro (1st Gen.)">Sell Broken gadgets</Link></li>
                  <li><Link to="/Airpods/AirPods (3rd Gen.)">Recycle your electronics securely</Link></li>
                  <br></br>
                  <li><Link to="/Airpods/AirPods Pro (2nd Gen.)">Sell AirPods Pro (2nd Gen.)</Link></li>
                  <li><Link to="/Airpods/AirPods Pro (1st Gen.)">Sell AirPods Pro (1st Gen.)</Link></li>
                  <li><Link to="/Airpods/AirPods (3rd Gen.)">Sell AirPods (3rd Gen.)</Link></li>
                  <li><Link to="/Airpods/AirPods Max">Sell AirPods Max</Link></li>
                  <li><Link to="/Airpods/HomePod (2nd Gen.)">Sell HomePod (2nd Gen.)</Link></li>
                  <li><Link to="/Airpods/AirPods (4th Gen.)">Sell AirPods (4th Gen.)</Link></li>
                  <li><Link to="/Airpods/AirPods (4th Gen.) Active Noise Cancellation">Sell AirPods (4th Gen.) Active Noise Cancellation</Link></li>
                </ul>

                </div>
                </div>
                <div className="col-lg-3 mb-5 mb-lg-0">
                          <h4 className="mb-4">CONTACT</h4>
                          <div className="address">
                              <span className="contect">
                                <CallIcon/> +1-437-808-7032<br />
                          10 am - 5 pm EST<br />
                          Mon to Fri
                          <hr/>
                          </span>
                              {/* <span className="email">
                                  <ContactSupport/> <Link onClick={() => {window.location.href ='/Support/CustomerSupport/SendTicket'}}>Send us an inquiry</Link>
                              </span> */}
                              <span className="contect">
                                  <Email/> info@cash4device.ca
                              </span>
                              <hr></hr>
                              <span className="time">
                              <WhatsApp/>            
                              <a  href="https://wa.me/14378087032?text=Hi%20I%20would%20like%20to%20chat%20with%20you" target='_blank'>    Chat with us on WhatsApp</a>
                                  {/*</a><Link to="https://wa.me/14375185960?text=Hi%20I%20would%20like%20to%20chat%20with%20you" target='_blank'>    Chat with us on WhatsApp</Link>*/}
                                  
                          </span>
                          </div>
                      </div>
                

                      <div className="col-lg-3 mb-5 mb-lg-0 mt-3">
                          <p className="pre-wrap lead mb-0">We do not accept products that have been reported lost or stolen and  iCloud or Activation locked
                      {/* <span className="no-wrap"><Link to="#"> Learn More</Link></span> */}
                          </p>
                      </div>
                  </div>
              </div>
          </footer>
                           
        </div>
      </div>
    )
  }
}

export default HomePage
